module.exports = __webpack_public_path__ + "4a9c4acdd23984f057ec4e8bc99a9987.jpeg";